module.exports = __webpack_public_path__ + "static/media/gdpr-spolfin.f6d41689.pdf";